import { render, staticRenderFns } from "./knit_stentering_stock_report.vue?vue&type=template&id=84689ffc&scoped=true"
import script from "./knit_stentering_stock_report.vue?vue&type=script&lang=js"
export * from "./knit_stentering_stock_report.vue?vue&type=script&lang=js"
import style0 from "./knit_stentering_stock_report.vue?vue&type=style&index=0&id=84689ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84689ffc",
  null
  
)

export default component.exports